import { OrderTicketDetails } from "../../interfaces"

const toNumberOrNull = (v: unknown): number | null => {
    if (v === null || v === undefined || v === '') return null
    const n = Number(v)
    return Number.isFinite(n) ? n : null
}

const toNumberOrZero = (v: unknown): number => {
    const n = toNumberOrNull(v)
    return n === null ? 0 : n
}

export const format3 = (v: number): string => Number(v).toFixed(3)

export const toTableRowItems = (items: OrderTicketDetails[]) =>
  items.map((item: OrderTicketDetails) => {
      const orderedQuantityRaw = toNumberOrNull(item.orderedQuantity)
      const receivedQuantityRaw = toNumberOrNull(item.receivedQuantity)

      const orderedQtyForCalc = toNumberOrZero(item.orderedQuantity)
      const receivedQtyForCalc = toNumberOrZero(item.receivedQuantity)

      const differenceRaw = orderedQtyForCalc - receivedQtyForCalc

      return {
          id: item.id,
          articleCode: item.articleCode ?? '',
          articleName: item.articleName ?? '',
          eanCode: item.eanCode ?? '',
          scannedCode: item.scannedCode ?? '',
          measureUnit: item.measureUnit ?? '',

          orderedQuantityRaw,
          receivedQuantityRaw,
          differenceRaw,

          orderedQuantityValue: orderedQtyForCalc,
          receivedQuantityValue: receivedQtyForCalc,

          orderedQuantity: format3(orderedQtyForCalc),
          receivedQuantity: format3(receivedQtyForCalc),
          difference: format3(differenceRaw),

          expirationDate: item.expirationDate ?? '',
          expirationDateRaw: item.expirationDate ?? null,

          packagingUnit: item.packagingUnit ?? 0,
          unitsPerLogisticUnit: item.unitsPerLogisticUnit ?? 0,
          pcbNumber: item.pcbNumber ?? 0,

          orderLineNumber: item.orderLineNumber ?? '',
          orderLineNumberRaw: toNumberOrNull(item.orderLineNumber),
      }
  })
